import React, { useState, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';

import ReactModal from 'react-modal';

import ProjectSlide from './components/ProjectSlide';
import SkillBar from './components/SkillBar';
import Testimonial from './components/Testimonial';
import ContactForm from './components/ContactForm';

import VideoPlayButton from './svg/VideoPlayButton.js';

import './App.scss';


function App() {

  const [activeNavItem, setActiveNavItem] = useState(null);

  const { ref: videoRef, inView: videoInView } = useInView({ threshold: 0.6 });
  const { ref: projectsRef, inView: projectsInView } = useInView({ 
    threshold: 0.2,  // Lower threshold for the larger projects section
    rootMargin: '-100px 0px'  // Optional: adds some offset to when it triggers
  });
  const { ref: skillsRef, inView: skillsInView } = useInView({ threshold: 0.6 });
  const { ref: testimonialsRef, inView: testimonialsInView } = useInView({ threshold: 0.6 });
  const { ref: contactRef, inView: contactInView } = useInView({ threshold: 0.6 });

  const [modalContent, setModalContent] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if(videoInView || contactInView)
      setActiveNavItem(null)

    if (projectsInView){
      setActiveNavItem('projects')
      document.querySelector('#projects.dormant')?.classList.remove('dormant');
    }
    
    if (skillsInView){
      setActiveNavItem('skills')
      document.querySelector('#skills.dormant')?.classList.remove('dormant');
    }
    
    if (testimonialsInView)
      setActiveNavItem('testimonials');
    
  }, [videoInView, projectsInView, skillsInView, testimonialsInView, contactInView]);


  useEffect(() => {
      const projectsScroller = document.querySelector('.projects-scroller');
      if (window.innerWidth < 1000) {
        projectsScroller.scrollLeft = -1000
      }

  }, []);

  const handleScrollTo = (id) => {
    
    // Incase the ref supplied isn't ref.current
    const el = document.getElementById(id)
    
    // Scroll the element into view
    el.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    })
  }


  const loadModal = async (apiUrl) => {
    try {
      setIsLoading(true);
      const response = await fetch(apiUrl);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const htmlContent = await response.text();
      setModalContent(htmlContent);
    } catch (error) {
      console.error('Error loading modal content:', error);
      setModalContent('Error loading content. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };


  return (<>
    {/* <div className="App"> */}

      <ReactModal 
        isOpen={modalContent !== null}
        onRequestClose={() => setModalContent(null)}
        ariaHideApp={false}
      >
        {isLoading ? (
          <div className="modal-loading">Loading...</div>
        ) : (<>
          <div id="modal-close-btn">
            <button onClick={()=>setModalContent(null)}>&times;</button>
          </div>
          <div 
            className="modal-content"
            dangerouslySetInnerHTML={{ __html: modalContent }}
          />
        </>)}
      </ReactModal>

      <div id="mainNav">
        <div className="mainNav-home">
          <button className="logo-button" onClick={(e)=>handleScrollTo("body")}>&nbsp;</button>
        </div>
        <ul className="mainNav-nav">
          <li className={activeNavItem==="projects"?"active":""}>
            <button className="font-normal" onClick={(e)=>handleScrollTo("projects")}>Projects</button>
          </li>
          <li className={activeNavItem==="skills"?"active":""} >
            <button className="font-normal" onClick={(e)=>handleScrollTo("skills")}>Skills</button>
          </li>
          <li className={activeNavItem==="testimonials"?"active":""}>
            <button className="font-normal" onClick={(e)=>handleScrollTo("testimonials")}>Testimonials</button>
          </li>
        </ul>
        <div className="mainNav-contact">
          {/* <a href="/Clint-Honeychurch-resume.pdf" target="_black" className="resume-btn">Resume</a> */}
          <a href="mailto:hey@clinthoney.church" className="contact-btn">
            <b className="contact-button">Contact<span> Me</span></b>
            <span className="honey-effect"></span>
          </a>
        </div>
      </div>

      <section id="video" ref={videoRef} style={{display:'none'}}>
        <div className="video-box">

          <div className="video-holder">

            <div className="video-player-box">
              {[1,2].map((i)=><div className="video-ticker" key={'video-ticker-'+i}>
                <span className="slide-1">
                ME IN UNDER 60 SECONDS &bull; ME IN UNDER 60 SECONDS &bull; ME IN UNDER 60 SECONDS &bull; ME IN UNDER 60 SECONDS &bull; ME IN UNDER 60 SECONDS &bull; ME IN UNDER 60 SECONDS &bull; 
                </span>
                <span className="slide-2">
                ME IN UNDER 60 SECONDS &bull; ME IN UNDER 60 SECONDS &bull; ME IN UNDER 60 SECONDS &bull; ME IN UNDER 60 SECONDS &bull; ME IN UNDER 60 SECONDS &bull; ME IN UNDER 60 SECONDS &bull; 
                </span>
              </div>)}
            </div>

            <div className="video-play-button">
              <VideoPlayButton />
            </div>

            <div className="video-player-shadow"></div>
          </div>

        </div>
        <div className="bg-circle-blur"></div>
      </section>

      <section id="projects" ref={projectsRef} className="dormant">
        <div className="projects-box">
        
          <h3 className="font-l font-heavy bold">
            PROJECTS
            <div className="drop honey-drop-m"></div>
          </h3>
          <p>Premium hand selected works from some<br className="mobile-br"/>of my favorite and most recents efforts</p>

          <div className="projects-scroller">
            <ProjectSlide 
              name="Sovrn" 
              text="Full-time software engineer working on an ad managment dashboard, part-time website redesigner" 
              bubbles="React, Frontend Development, Web Design, Custom Dashboard, Custom Wordpress"
              apiUrl="/api/sovrn"
              loadModal={loadModal}
            />
            <ProjectSlide 
              name="Snopes" 
              text="I was lucky enough to be a part of the Snopes website rebranding effort, great results with an even greater team"
              bubbles="Rebranding, Web Design, Custom Wordpress, Illustration, Video"
              apiUrl="/api/snopes"
              loadModal={loadModal}
            />
            <ProjectSlide 
              name="Proper Media" 
              text="Full frontend redesign and development of a saas dashboard, from Photoshop to React and back"
              bubbles="Web Design, Frontend Development, Custom Dashboard, React"
              apiUrl="/api/proper-media"
              loadModal={loadModal}
            />
            <ProjectSlide 
              name="TVTropes" 
              text="Another great project I lucked into, where I got to play equal parts designer and developer for an entire wiki" 
              bubbles="Rebranding, Web Design, Fronend Development, Javascript, PHP"
              apiUrl="/api/tvtropes"
              loadModal={loadModal}
            />
            <ProjectSlide 
              name="Onside Sports" 
              text="Super cool app that needed an equally cool UI/UX and branding package" 
              bubbles="Branding, Photoshop, Web Design, Product Design, App Design, UI/UX"
              apiUrl="/api/onside-sports"
              loadModal={loadModal}
            />
            <ProjectSlide 
              name="Double Fine" 
              text="A life changing dream job in the gaming industry, I still can't believe it was real" 
              bubbles="Web Design, Fronend Development, PHP, Javascript, Photoshop, UI/UX"
              apiUrl="/api/double-fine"
              loadModal={loadModal} />
          </div>

          <img src="/images/section-projects-logos.png" alt="logos" className="logos-bar" />

        </div>
      </section>

      <section id="skills" ref={skillsRef} className="dormant">
        <div className="skill-box">

          <h3 className="font-l font-heavy bold">
            SKILLS
            <div className="drop honey-drop-m"></div>
            <div className="drop honey-drop-s"></div>
          </h3>
          <p>Expertly crafted and<br className="mobile-br"/>continuously fine tuned to perfection</p>

          <div className="skills-box">
            <div className="left">
              <h4 className="font-heavy">DESIGN</h4>
              <SkillBar name="Photoshop" description="Images, Web Design & Polish" percent="100" />
              <SkillBar name="Figma" description="Wireframing, Prototyping" percent="94" />
              <SkillBar name="After Effects & Animate" description="Videos, Animated Assets" percent="80" />
              <SkillBar name="Spline & Blender3D" description="3D Assets & Animation" percent="68" />
            </div>
            <div className="right">
              <h4 className="font-heavy">CODE</h4>
              <SkillBar name="HTML & CSS" description="Frontend" percent="100" />
              <SkillBar name="Javascript & ReactJS" description="Frontend, Backend" percent="96" />
              <SkillBar name="Git, CI/CD" description="Version control and development" percent="88" />
              <SkillBar name="PHP, NodeJS, Others" description="Backend languages and +more" percent="54" />
            </div>
          </div>

          <div className="bg-circle-blur"></div>

        </div>
      </section>

      <section ref={testimonialsRef} id="testimonials">
        <div className="testimonials-box">

          <h3 className="font-l font-heavy bold">TESTIMONIALS</h3>
          <p>Sugary sweet utterances<br className="mobile-br"/>from higher-ups, about me</p>
          <div className="testimonials-holder">
            <Testimonial 
              name="Daniel Braha" 
              title="VP, Brand & Product Design @Sovrn" 
              weblink="https://www.sosmedia.com" 
              linkedin="https://www.linkedin.com/in/danielbraha/"
              drop={<div className="drop honey-drop-m"></div>}>
            Clint is a unicorn, <b>a true designer engineer</b> who can design, illustrate, animate, and code. He's someone you want on your team when you care about the quality of the work and the experience of getting there. I'd work with him again in a heartbeat.
            </Testimonial>
            <Testimonial 
              name="Dirk Merkel" 
              title="Software Engineer & Executive Leader" 
              linkedin="https://www.linkedin.com/in/dirkmerkel/"
              drop={<div className="drop honey-drop-s"></div>}>
              Clint has an <b>unwavering sense of ownership</b> over his projects. He not only tackles challenges head-on but also sees every project through with an exceptional level of dedication, ensuring that the end result not only meets but exceeds expectations.           </Testimonial>
          </div>

          <div className="bg-circle-blur"></div>

        </div>
      </section>

      <section id="contact" ref={contactRef}>
        <h3 className="font-l font-heavy bold">SO..</h3>
        <p>How long are we going to stare silently at eachother?</p>

        <div className="contact-box">
          <ContactForm />
          <div className="drop honey-drop-m"></div>
        </div>
      </section>


      <footer>
        <div className="footer-box">

          <div className="footer-left">
            <button className="logo-button" onClick={(e)=>handleScrollTo("body")}>&nbsp;</button>
            <div className="font-s">&copy; {new Date().getFullYear()} Clint Honeychurch. All rights reserved.</div>
          </div>

          <div className="footer-right">
            <a href="https://en.wikipedia.org/wiki/Klint_Honeychurch" target="_blank" rel="noreferrer">
              <img src="../images/icon-wiki.png" alt="linkedin" />
            </a>
            <a href="https://dribbble.com/sugartemple/" target="_blank" rel="noreferrer">
              <img src="../images/icon-dribbble.png" alt="dribbble" />
            </a>
            <a href="https://github.com/khoneychurch/" target="_blank" rel="noreferrer">
              <img src="../images/icon-git.png" alt="github" />
            </a>
            <a href="https://www.linkedin.com/in/clint-honeychurch/" target="_blank" rel="noreferrer">
              <img src="../images/icon-linkedin.png" alt="linkedin" />
            </a>
            <a href="mailto:hey@clinthoney.church" className="contact-button">Contact<span> Me</span></a>
          </div>

        </div>

      </footer>


    {/* </div> */}
  </>);
}

export default App;
